import { z } from 'zod';
import { Validation } from '@mews/framework';
import { SellLimitFieldNames } from '../../components/fieldNames';
import { allSpacesSchema, rateSchema, resourceCategorySchema } from './common';

export const MAX_SELL_LIMIT_SPACES = 9999;
export const MIN_SELL_LIMIT_SPACES = 0;

export const addSellLimitFormSchema = z.object({
    [SellLimitFieldNames.NUMBER_OF_SPACES_FIELD_NAME]: z
        .number()
        .int()
        .min(MIN_SELL_LIMIT_SPACES)
        .max(MAX_SELL_LIMIT_SPACES),
    [SellLimitFieldNames.LIMIT_START_FIELD_NAME]: Validation.DateTime.Utc,
    [SellLimitFieldNames.LIMIT_END_FIELD_NAME]: Validation.DateTime.Utc,
    [SellLimitFieldNames.DAYS_FIELD_NAME]: z.array(z.string()).nonempty(),
    [SellLimitFieldNames.RATE_SELECT_OPTION_FIELD_NAME]: rateSchema,
    [SellLimitFieldNames.SPACE_SELECT_OPTION_FIELD_NAME]: z.discriminatedUnion('type', [
        allSpacesSchema,
        resourceCategorySchema,
    ]),
});

export type AddSellLimitFormModel = z.infer<typeof addSellLimitFormSchema>;
